<template>
  <!-- NOTE (TEMPLATE) to show the specific proposal page -->

  <div>
    <!-- loading component -->
    <Loading />
    <Opportunity role="university" />
  </div>
</template>

<script>
const Opportunity = () => import("../../components/Opportunity");

export default {
  components: { Opportunity }, // NOTE (COMPONENT) component of proposal
  data() {
    return {};
  },
  mounted() {
    // NOTE (MOUNTED) to show loading at the beginning
    this.$bvModal.show("loading");
  }
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}
</style>
